import { api } from './api';
import type { LoginCredentials, User, AuthResponse } from '../types/auth';

export const authService = {
  /**
   * Login with email and password
   * Returns user data and sets HttpOnly cookies
   */
  async login(credentials: LoginCredentials): Promise<User> {
    const response = await api.post<AuthResponse>('/api/auth/login', credentials);
    return response.data.user;
  },

  /**
   * Logout and clear session
   */
  async logout(): Promise<void> {
    await api.post('/api/auth/logout');
  },

  /**
   * Get current authenticated user
   */
  async getMe(): Promise<User> {
    const response = await api.get<AuthResponse>('/api/auth/me');
    return response.data.user;
  },

  /**
   * Refresh access token using refresh token from HttpOnly cookie
   */
  async refresh(): Promise<void> {
    await api.post('/api/auth/refresh');
  },

  /**
   * Request a password reset email
   */
  async forgotPassword(email: string): Promise<string> {
    const response = await api.post<{ message: string }>('/api/auth/forgot-password', { email });
    return response.data.message;
  },

  /**
   * Reset password with token
   */
  async resetPassword(token: string, password: string): Promise<string> {
    const response = await api.post<{ message: string }>('/api/auth/reset-password', { token, password });
    return response.data.message;
  },
};
